import React from 'react';
import BaseModal from '../baseModal';
import { authenticate } from '../../services/auth';

const WoopsModal = ({ show, setShow, close }) => {
  return (
    <BaseModal show={show} setShow={setShow} handleClose={close}>
      <div className="broadcast-modal-tx__buttons">
        <button className="button" onClick={() => window.open("https://docs.derupt.io/user/get-started")}>Get Started</button>
        <button className="button" onClick={() => authenticate()} >Connect Wallet</button>
      </div>
    </BaseModal>
  )
}

export default WoopsModal;